import { IChipAmounts } from '../interfaces';

export const sortChipsAmounts = (chipsAmounts: IChipAmounts): IChipAmounts =>
    Object.fromEntries(Object.entries(chipsAmounts).sort(([a], [b]) => a.localeCompare(b)));
